module.exports = __webpack_public_path__ + "img/2.955e3f2.png";